module.exports = __webpack_public_path__ + "img/mPoint.f3559011.svg";